import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header"
import Footer from "./Footer"

const PublicAppLayout = () => {


  return (
    <>
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default PublicAppLayout;


